import { useEffect, useState } from 'react'
import { workerOptionsStore } from '../services/workerOptionsStore'

export function useWorkerOptions() {
  const [options, setOptions] = useState(workerOptionsStore.getAll())

  useEffect(
    () =>
      workerOptionsStore.subscribe(() =>
        setOptions(workerOptionsStore.getAll()),
      ),
    [],
  )

  return {
    options,
    addOption: workerOptionsStore.add.bind(workerOptionsStore),
  }
}
